import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "37",
  height: "40",
  viewBox: "0 0 18.07 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.735 2.014V1.4h1.329a.7.7 0 1 0 0-1.4H7.007a.7.7 0 1 0 0 1.4h1.329v.615a9.04 9.04 0 0 0-8.336 9c.5 11.986 17.576 11.982 18.07 0a9.04 9.04 0 0 0-8.336-9zm3.128 9.7H9.035a.7.7 0 0 1-.7-.7V5.557a.7.7 0 1 1 1.4 0v4.755h3.128a.7.7 0 0 1 0 1.4z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };